export default __webpack_public_path__ + "static/media/8Y.cefea39b.png";